import { NavLink } from "react-router-dom";
import "../styles/layout.css";
import { useAuth } from "../context/AuthContext";


const Sidebar = ({ show, setShow }) => {
  const { user } = useAuth();
  return (
    <div className={`sidebar ${show ? "show" : ""}`}>
      <h2>Pages</h2>
      <br />
      <hr />
      <nav>
        {user && <NavLink to="/user" onClick={() => setShow(false)} className={"sidebarLink"}>Profile</NavLink>}
        <NavLink to="/books" onClick={() => setShow(false)} className={"sidebarLink"}>Books</NavLink>
        <NavLink to="/orders" onClick={() => setShow(false)} className={"sidebarLink"}>Orders</NavLink>
        <NavLink to="/cart" onClick={() => setShow(false)} className={"sidebarLink"}>Cart</NavLink>
        {user && <NavLink to="/contact" onClick={() => setShow(false)} className={"sidebarLink"}>Contact</NavLink>}
        <NavLink to="/" onClick={() => setShow(false)} className={"sidebarLink"}>About</NavLink>
        <NavLink to="/global" onClick={() => setShow(false)} className={"sidebarLink"}>Global Chat</NavLink>
        {!user && <NavLink to="/login" onClick={() => setShow(false)} className={"sidebarLink"}>Login</NavLink>}
        {!user && <NavLink to="/register" onClick={() => setShow(false)} className={"sidebarLink"}>Signup</NavLink>}
      </nav>
      {!user && <NavLink to={"/login"} className={"btn sidebarLogin"}>Login</NavLink>}
    </div>
  );
};

export default Sidebar;
